import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  fetchGallery: ['slug'],
  fetchGalleryStart: null,
  fetchGallerySuccess: ['galleryData'],
  fetchGalleryFailure: null,
  fetchOldGallery: ['slug'],
  fetchOldGalleryStart: null,
  fetchOldGallerySuccess: ['oldGalleryData'],
  fetchOldGalleryFailure: null
});

export { Types, Creators };
